import api from '../utils/api';

const idCardsService = {
  generateCard: async (personType, personId, data) => {
    try {
      return await api.post(`/api/id-cards/${personType}/${personId}/generate`, data || {});
    } catch (error) {
      console.error('Error generating ID card:', error);
      throw error;
    }
  },
  listCards: async (params) => {
    try {
      return await api.get('/api/id-cards/', { params });
    } catch (error) {
      console.error('Error fetching ID cards:', error);
      throw error;
    }
  },
  bulkGenerate: async (personType, personIds, expiryDate) => {
    try {
      return await api.post('/api/id-cards/bulk-generate', {
        person_type: personType,
        person_ids: personIds,
        expiry_date: expiryDate || null,
      });
    } catch (error) {
      console.error('Error bulk-generating ID cards:', error);
      throw error;
    }
  },
  distributeCard: async (cardId, note) => {
    try {
      return await api.post(`/api/id-cards/${cardId}/distribute`, { note: note || null });
    } catch (error) {
      console.error('Error marking ID card distributed:', error);
      throw error;
    }
  },
  updateCard: async (cardId, data) => {
    try {
      return await api.put(`/api/id-cards/${cardId}`, data);
    } catch (error) {
      console.error('Error updating ID card:', error);
      throw error;
    }
  },
  deleteCard: async (cardId) => {
    try {
      return await api.delete(`/api/id-cards/${cardId}`);
    } catch (error) {
      console.error('Error deleting ID card:', error);
      throw error;
    }
  },
  // Returns the raw fetch Response — caller does response.blob() and
  // triggers the download.
  downloadCardPdf: async (cardId) => {
    try {
      return await api.get(`/api/id-cards/${cardId}/pdf`, { raw: true });
    } catch (error) {
      console.error('Error downloading ID card PDF:', error);
      throw error;
    }
  },
  verifyCard: async (cardNumber) => {
    try {
      return await api.get(`/api/id-cards/verify/${cardNumber}`);
    } catch (error) {
      console.error('Error verifying ID card:', error);
      throw error;
    }
  },
};

export default idCardsService;
